/**
 * 会员营销 - 会员分群-人群标签
 */

import { get, post, postJson, deleteApi, deleteApiJson } from '../axios'

const RESOURCE_BASE_PATH = '/memberLabel/'

// 获取人群标签
export const getLabel = p => get(`${RESOURCE_BASE_PATH}`, p);

// 获取咚咚客服工具人群标签
export const getDdLabel = p => get(`${RESOURCE_BASE_PATH}dong/attribute/list`, p);

// 获取咚咚客服工具标签属性
export const getDdAttr = p => get(`${RESOURCE_BASE_PATH}dong/label/list`, p);

// 计算人群数量
export const compute = p => postJson(`${RESOURCE_BASE_PATH}compute`, p);

// 获取自定义渠道id列表
export const getCustomQdIdList = p => get(`${RESOURCE_BASE_PATH}precision-channel-id-custom/list`, p);

// 批量删除自定义渠道id
export const delCustomQdId = p => deleteApiJson(`${RESOURCE_BASE_PATH}precision-channel-id-custom`, p);

// 自定义渠道id添加
export const addCustomQdId = p => postJson(`${RESOURCE_BASE_PATH}precision-channel-id-custom`, p);

// 自定义渠道id添加
export const activityList = p => get(`/hd/unite/activity/list`, p);